import { render, staticRenderFns } from "./reviewListTab.vue?vue&type=template&id=9a67f230&lang=pug"
import script from "./reviewListTab.vue?vue&type=script&lang=js"
export * from "./reviewListTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports